import './DealerAccessSidebar.scss';
import { ContentBlockSkeleton } from '@gplibraries/react/components';
import {
  useTokenProvider,
  useDealerInfo,
  useConfig,
  useAssociatedDealers, useAuthorizer,
} from '@gplibraries/react/hooks';
import { fetchTmInfo } from '@gplibraries/react/api';
import { useQuery } from '@tanstack/react-query';
import DealerInfoBlock from './Blocks/DealerInfoBlock';
import AdminBlock from "./Blocks/AdminBlock";
import PrimaryDealerContactBlock from './Blocks/PrimaryDealerContactBlock';
import TmInfoBlock from './Blocks/TmInfoBlock.js';
import ContentManagementBlock from './Blocks/ContentManagementBlock.js';

export default function DealerAccessSidebar() {

  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const drupalScope = useConfig('drupalScope');
  const getMiddlewareToken = useTokenProvider({ scopes: ['openid', dealerAccessApiScope]});
  const getDrupalToken = useTokenProvider({ scopes: ['openid', drupalScope]});

  const { data: associatedDealers } = useAssociatedDealers();
  const { data: dealer, loading: dealerLoading, error: dealerError } = useDealerInfo();

  // middleware token query
  const { data: token } = useQuery({
    enabled: Boolean(getMiddlewareToken),
    queryKey: ['middlewareToken'],
    queryFn: () => getMiddlewareToken()
  });

  // drupal token query
  const { data: drupalToken } = useQuery({
    enabled: Boolean(getDrupalToken),
    queryKey: ['drupalToken'],
    queryFn: () => getDrupalToken()
  });

  const user = useAuthorizer(token?.accessTokenClaims);
  const drupalUser = useAuthorizer(drupalToken?.accessTokenClaims);

  const { isLoading, error: tmError, data: tm } = useQuery({
    enabled: (dealer?.territory) ? true : false,
    queryKey: ['tm_info'],
    queryFn: () => getMiddlewareToken()
      .then(token => fetchTmInfo(dealerAccessApiHost,token.accessToken, dealer.territory))
      .then(res => res.json()),
    select: (res) => res.data
  });

  if (dealerError) throw dealerError;
  if (tmError) throw tmError;

  return (

    <div className={'flex-col sidebar-content'}>

      {dealer &&
        <DealerInfoBlock dealer={dealer} user={user} associatedDealers={associatedDealers}/>
      }

      {dealer?.primary_contact &&
        <PrimaryDealerContactBlock name={dealer.primary_contact?.name} email={dealer.primary_contact.email}/>
      }

      {tm &&
        <TmInfoBlock tm={tm}/>
      }

      {/* Show content editing links if the drupal user has a role other than base_permissions. */}
      {(Boolean(drupalUser?.get('roles')?.length) && !drupalUser?.get('roles')?.every(r => r === 'base_permissions')) &&
        <ContentManagementBlock user={drupalUser}/>
      }

      {(user?.isAdmin() || user?.isCsUser()) &&
        <AdminBlock token={token}/>
      }

      {/*
        Skeleton loaders - putting them at the end to make sure they don't appear
        before or in between blocks that are loaded.
       */}

      {(isLoading || dealerLoading) && <ContentBlockSkeleton hasTitle={true} />}
      {(isLoading || dealerLoading) && <ContentBlockSkeleton hasTitle={true} />}
      {(isLoading || dealerLoading) && <ContentBlockSkeleton hasTitle={true} />}

    </div>
  );
}